<template>
  <div class="test_call">
    <!--      <div class="modal-background"></div>-->
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="modal-card-title"><div class="control"><label class="label">{{$t('testCall.testCall')}}</label></div></div>
        <button class="delete" aria-label="close" v-on:click="closeTestCall()" :title="$t('common.actions.close')"></button>
      </header>
      <section class="modal-card-body" :class="testPhoneParametersArray.length>3 ? 'scrolled' : ''">
        <div class="control is-grouped">
          <p class="control is-expanded">
            <input v-show="false" :v-model="webRtcDialplanCondition" placeholder="webRtcDialplanCondition" class="webRtcDialplanCondition"/>
<!--            <vb-switch-with-two-labels v-if="!!webRtcDialplanCondition && tmp.campaignList.length " :model.sync="callToPhone" :label-left="$t('testCall.calInBrowser')" :label-right="$t('testCall.callToPhone')"  :onchange="callToPhoneOnChangeEvent"/>-->
            <vb-switch-with-two-labels :model.sync="callToPhone" :label-left="$t('testCall.calInBrowser')" :label-right="$t('testCall.callToPhone')"  :onchange="callToPhoneOnChangeEvent"/>
            <input v-show="!!callToPhone && tmp.campaignList.length" v-model="testPhone" class="input phone" type="text" :placeholder="$t('callTasks.phoneNumber')">
            <div v-show="!!callToPhone && tmp.campaignList.length" class="select">
              <select v-model="tmp.campaignId">
                <option v-for="campaign in tmp.campaignList" v-bind:value="campaign.id">{{campaign.name}}</option>
              </select>
            </div>
          </p>
        </div>
        <div class="is-small note">
          <div v-if="callToPhone">{{$t('testCall.toPhoneNote')}}</div>
          <div v-else>{{$t('testCall.inBrowserNote')}}</div>
        </div>
        <div class="control">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th>{{$t('common.key')}}</th>
                <th>{{$t('common.value')}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(param, index) in testPhoneParametersArray">
                <td>
                  <input v-model="param[0]" class="input" type="text">
                </td>
                <td>
                  <input v-model="param[1]" class="input" type="text">
                </td>
                <td>
                  <button class="button is-light" v-on:click="deleteTestPhoneParameter(index)" style="width:100%">
                          <span class="icon">
                            <i class="fa fa-minus-circle"></i>
                          </span>
                    <span>{{$t('common.actions.delete')}}</span>
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <button class="button is-light addParam" v-on:click="addTestPhoneParameter" style="width:100%">
                          <span class="icon">
                            <i class="fa fa-plus-circle"></i>
                          </span>
                    <span>{{$t('common.actions.add')}}</span>
                  </button>
                </td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary" v-on:click="callTest()" :disabled="(callToPhone && !testPhone) || (!callToPhone && !webRtcDialplanCondition) || creatingTestCall" >
          <span class="icon" v-if="callToPhone"><i class="fas fa-phone-volume"></i></span>
          <span class="icon" v-else><i class="fas fa-headset"></i></span>
          <span>{{$t('testCall.call')}}</span>
        </button>
        <button class="button" v-on:click="closeTestCall()" v-bind:title="$t('common.actions.close')">{{$t('common.actions.cancel')}}</button>
      </footer>
      <DebugDialog v-if="debuggingDialog" :on-finish="onDialogFinish" :on-new-message="onDialogNewMessage" :web-socket-session-id.sync="webSocketSessionId"/>
    </div>

    <audio class="remoteAudio"></audio>
    <audio class="localAudio"></audio>
  </div>
</template>

<script>

  import DebugDialog from './DebugDialog'

  import VbSwitchWithTwoLabels from '../../components/VbSwitchWithTwoLabels'
  import BaseComponent from '../BaseComponent'
  import { Web } from 'sip.js'

  const GET_CAMPAIGNS_API = '/api/scenarios/getCampaigns'
  const CAMPAIGNS_API = '/api/campaigns'
  const CALLTASKTESTING_API = '/api/callTasks/testCall'
  const WEBRTC_DIALPLAN_CONDITION = 'api/appConfig/dialplanCondition'

  export default {
    name: 'TestCall',
    components: {DebugDialog, VbSwitchWithTwoLabels},
    extends: BaseComponent,
    props: ['campaignId', 'scenario', 'closeTestCall'],
    data() {
        return {
          callToPhone: true,
          testPhone: '',
          creatingTestCall: false,
          testPhoneParametersArray: [
            {
              key: '',
              value: ''
            }
          ],
          tmp: {
            campaignId: '',
            campaignList: []
          },
          debuggingDialog: false,
          webSocketSessionId: '',

          webRtcSimple: null,
          webRtcDialplanCondition: ''
        }
    },
    methods: {
      prepareSecurityHeader() {
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },

      deleteTestPhoneParameter(index) {
        this.testPhoneParametersArray.splice(index, 1)
      },
      addTestPhoneParameter() {
        this.testPhoneParametersArray.push({})
      },

      prepareTestPhone (campaignId, testPhone, testPhoneParametersArray) {
        let testCallTaskDto = {
          phone : testPhone,
          campaign : campaignId,
          parameters : {}
        }
        testCallTaskDto.parameters = testPhoneParametersArray
        this.saveTestCallParamsToCookie(testCallTaskDto)
        return testCallTaskDto
      },
      saveTestCallParamsToCookie(testCallTaskDto) {
        let name = 'app.ivoice.online.testCall.' + testCallTaskDto.campaign
        let value = 'phone:' + testCallTaskDto.phone
        for (let parameter in testCallTaskDto.parameters) {
          if (parameter && parameter !== 'undefined' && parameter !== 'webDomen' && parameter !== 'webSocketSessionId') {
            value += ('_' + parameter + ':' + testCallTaskDto.parameters[parameter])
          }
        }

        document.cookie = name + '=' + value
      },
      getTestCallParamsFromCookie(campaignId) {
        let name = 'app.ivoice.online.testCall.' + campaignId
        // let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))
        let matches = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
        if (matches && matches.length && matches.length > 1) {
          let testCallTaskStr = matches ? decodeURIComponent(matches[2]) : undefined
          if (testCallTaskStr) {
            let testCallTaskDto = {
              phone: '',
              parameters: {}
            }
            let paramsArray = testCallTaskStr.split('_')
            for (let i = 0; i < paramsArray.length; i++) {
              let param = paramsArray[i].split(':')
              if (i === 0 && param[0] === 'phone') {
                testCallTaskDto.phone = param[1]
              } else {
                testCallTaskDto.parameters[param[0]] = param[1]
              }
            }
            return testCallTaskDto
          }
        }
        return undefined
      },
      guid() {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
        }

        return (
          s4() +
          s4() +
          '-' +
          s4() +
          '-' +
          s4() +
          '-' +
          s4() +
          '-' +
          s4() +
          s4() +
          s4()
        )
      },
      prepareTestPhoneParameters() {
        this.webSocketSessionId = this.guid()

        let params = {}
        if (this.testPhoneParametersArray) {
          for (let i = 0; i < this.testPhoneParametersArray.length; i++) {
            if (this.testPhoneParametersArray[i][0] && this.testPhoneParametersArray[i][0] !== 'undefined') {
              params[this.testPhoneParametersArray[i][0]] = this.testPhoneParametersArray[i][1]
            }
          }
        }
        params.webDomen = 'https://' + document.location.host + '/api/dialogState/receive'
        params.webSocketSessionId = this.webSocketSessionId

        return params
      },
      callTestToPhone() {
        let that = this
        // if (this.testPhone.trim() !== '' && this.tmp.campaignId && this.tmp.campaignId !== '0') {
        this.creatingTestCall = true
        console.log('saving new testing call task: ' + JSON.stringify(this.testPhone))
        this.$http.post(CALLTASKTESTING_API, this.prepareTestPhone(this.tmp.campaignId, this.testPhone, this.prepareTestPhoneParameters()), {headers: this.prepareSecurityHeader()})
          .then(() => {
            this.creatingTestCall = false
            that.openNotificationWithType('success', that.$i18n.messages[this.$i18n.locale].notifications.testCall.testCallActivated)
            // that.debuggingDialog = true // ToDo
          }).catch((error) => {
          this.creatingTestCall = false
          console.log(error)
          that.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.testCall.errorCreatingTestCall)
        })
      },
      initWebRtc() {
        let options = {
          media: {
            local: {
              audio: this.$el.getElementsByClassName('localAudio')[0]
            },
            remote: {
              audio: this.$el.getElementsByClassName('remoteAudio')[0]
            },
            constraints: { audio: true, video: false } // audio only call
          },
          aor: 'sip:1010@ws.tehnoprom.ivoice.online', // caller
          userAgentOptions: {
            authorizationUsername: '1010',
            authorizationPassword: 'ivoice123'
          },
          delegate: {
            onCallCreated: function() {
              console.log('onCallCreated. ')
            },
            onCallAnswered: function() {
              console.log('onCallAnswered. ')
            },
            onCallReceived: function(data) {
              console.log('onCallReceived. ' + data)
            },
            onMessageReceived: function(data) {
              console.log('onMessageReceived. ' + data)
            },
            onCallHangup: function() {
              console.log('onCallHangup. ')
            },
            onServerDisconnect: function() {
              console.log('onServerDisconnect. ')
            }
          }
        }

        let simple = new Web.SimpleUser('wss://ws.tehnoprom.ivoice.online:7443', options)

        return simple
      },
      callTestInBrowser() {
        let that = this
        this.webSocketSessionId = this.guid()
        this.creatingTestCall = true
        this.$http.post(CAMPAIGNS_API + '/prepareForWebRtc/' + this._props.scenario.id, {}, {headers: this.prepareSecurityHeader()})
          .then(() => {
            that.creatingTestCall = false
            that.webRtcSimple.connect()
              .then(() => that.webRtcSimple.call('sip:' + that.webRtcDialplanCondition + '@ws.tehnoprom.ivoice.online'))
              .catch((error) => {
                console.log('error. ' + error)
              })
            // that.debuggingDialog = true // ToDo
          }).catch((error) => {
            that.creatingTestCall = false
            console.log(error)
            that.openNotificationWithType('danger', that.$i18n.messages[this.$i18n.locale].notifications.testCall.errorCreatingTestCall)
          })
      },
      callTest () {
        if (this.callToPhone) {
          this.callTestToPhone()
        } else {
          this.callTestInBrowser()
        }
      },
      onDialogFinish() {
        this.debuggingDialog = false
        console.log('onDialogFinish ')
      },
      onDialogNewMessage(nodeId) {
        // ToDo
        console.log('onDialogNewMessage ' + nodeId)
      },
      loadCampaignList(scenarioId) {
        let that = this
        if (scenarioId || this._props.scenario.id) {
          this.$http({
            url: GET_CAMPAIGNS_API + '/' + (scenarioId || this._props.scenario.id),
            headers: this.prepareSecurityHeader()
          }).then((response) => {
            let campaignIds = response.data
            if (campaignIds && campaignIds.length > 0) {
              that.tmp.campaignList = campaignIds
              this.setCampaignId(that.tmp.campaignList[0].id)
            } else {
              that.callToPhone = false
            }
          }).catch((error) => {
            console.log(error)
          })
        }
      },
      initCampaign(scenarioId) {
        if (!this._props.campaignId || this._props.campaignId === '0') {
          this.loadCampaignList(scenarioId)
        } else {
          this.tmp.campaignList = [this._props.campaignId]
          this.setCampaignId(this.tmp.campaignList[0].id)
        }
      },
      setCampaignId(campaignId) {
        this.tmp.campaignId = campaignId
        let testCallTaskDto = this.getTestCallParamsFromCookie(campaignId)
        if (testCallTaskDto) {
          this.testPhone = testCallTaskDto.phone
          if (testCallTaskDto.parameters && Object.entries(testCallTaskDto.parameters).length) {
            this.testPhoneParametersArray = []
            for (let parameter in testCallTaskDto.parameters) {
              this.testPhoneParametersArray.push([parameter, testCallTaskDto.parameters[parameter]])
            }
          }
        }
      },
      callToPhoneOnChangeEvent(val) {
        this.callToPhone = !!val
      },

      loadWebRtcDialplanCondition() {
        let that = this
        this.$http({
          url: WEBRTC_DIALPLAN_CONDITION,
          headers: this.prepareSecurityHeader()
        }).then((response) => {
          that.webRtcDialplanCondition = response.data
        }).catch((error) => {
          console.log(error)
          that.callToPhone = true
        })
      }
    },
    created () {
      this.loadWebRtcDialplanCondition()
      this.initCampaign(this._props.scenario ? this._props.scenario.id : null)
    },
    mounted() {
      this.webRtcSimple = this.initWebRtc()
    }
  }
</script>

<style scoped>
  .test_call {
    position:absolute;
    z-index: 3001;
    /*width: 512px;*/
    padding: 16px 16px 16px 16px;
    background-color: lightgray;
    height: auto;
    border-color: gray;
    border-style: solid;
    /*top:6px;*/
    right: 100px;
  }

  .test_call .modal-card-title {
    padding: 12px 12px 12px 16px;
    font-size: 1.1rem;
  }
  .test_call .modal-card-head {
    padding: 2px 13px 2px 2px;
  }
  .test_call .modal-card-body {
    max-height: 300px;
    padding: 16px;
  }
  .test_call .modal-card-body.scrolled {
    overflow-y: scroll;
  }
  .test_call .modal-card-foot{
    padding: 16px;
  }
  .test_call table{
    margin-bottom: 0;
  }
  .test_call table button.addParam{
    margin-bottom: 0;
  }

  .phone {
    max-width: 144px;
  }
  .webRtcDialplanCondition {
    max-width: 177px;
  }

  .VbSwitchWithTwoLabels {
    vertical-align: sub;
    height: 35px;
  }

  .note {
    margin-bottom: 32px;
    margin-top:-8px;
    font-size: smaller;
  }
</style>



// WEBPACK FOOTER //
// TestCall.vue?20fca876